import { SituationRoutes } from './situation/situation.routing';
import { OfferRoutes } from './offer/offer.routing';
import { ContractRoutes } from './contract/contract.routing';
import { SummaryRoutes } from './summary/summary.routing';
import { ThankYouRoutes } from './thankYou/thankYou.routing';

export const NewQuotation = [
  ...SituationRoutes,
  ...OfferRoutes,
  ...ContractRoutes,
  ...SummaryRoutes,
  ...ThankYouRoutes,
];
